import type { IRiskCatalogueScenarioCode } from '@/lib/constants/riskCatalogueScenarios'

export const RISK_CATALOGUE_SCENARIO_TEXTS = {
  'RS-001': {
    NAME: 'Paralización de operaciones sin un plan de continuidad probado',
    DESCRIPTION:
      'Las operaciones críticas se paralizan por falta de planificación de la continuidad (no hay un plan de continuidad de negocio probado).',
  },
  'RS-002': {
    NAME: 'Caída prolongada de un proveedor SaaS crítico',
    DESCRIPTION:
      'Un proveedor SaaS crítico sufre una caída prolongada. No hay un SLA adecuado, ni evaluación de la resiliencia del proveedor, ni un proveedor alternativo.',
  },
  'RS-003': {
    NAME: 'Corte eléctrico regional en la zona de disponibilidad cloud',
    DESCRIPTION:
      'Un corte eléctrico regional afecta a la zona de disponibilidad cloud. La arquitectura depende de una única zona, sin conmutación por error ni un plan de recuperación ante desastres probado.',
  },
  'RS-004': {
    NAME: 'Caída de la red troncal del proveedor de internet',
    DESCRIPTION:
      'El proveedor de internet principal sufre una caída de su red troncal. Los servicios cloud quedan inaccesibles por un punto único de fallo y la falta de rutas redundantes.',
  },
  'RS-005': {
    NAME: 'Fallo de equipos de red sin redundancia',
    DESCRIPTION:
      'Fallan los equipos de red y no hay conectividad redundante. El personal remoto pierde el acceso a los servicios cloud y no puede mantener las operaciones.',
  },
  'RS-006': {
    NAME: 'Fallo de un servicio cloud por una vulnerabilidad sin parchear',
    DESCRIPTION:
      'Un servicio cloud clave falla por una vulnerabilidad de software conocida pero sin parchear. Ningún proceso de gestión de vulnerabilidades prioriza su corrección.',
  },
  'RS-007': {
    NAME: 'Ataque DDoS contra la infraestructura cloud',
    DESCRIPTION:
      'Un ataque DDoS desborda la infraestructura cloud. No hay segmentación de VPC que contenga el impacto y el autoescalado está mal configurado.',
  },
  'RS-008': {
    NAME: 'Deriva de configuración que provoca un fallo en cascada',
    DESCRIPTION:
      'La infraestructura se desvía de la configuración prevista con el tiempo. Ningún análisis de IaC detecta la deriva y una actualización rutinaria provoca un fallo en cascada.',
  },
  'RS-009': {
    NAME: 'Ataque de sabotaje dirigido',
    DESCRIPTION:
      'Un ataque de sabotaje dirigido explota una arquitectura de red insegura. No existe un plan de respuesta a incidentes y la monitorización de brechas es insuficiente.',
  },
  'RS-010': {
    NAME: 'Spear phishing dirigido a nuevos empleados',
    DESCRIPTION:
      'Una campaña de spear phishing se dirige a nuevos empleados que se incorporaron sin un proceso formal de acogida en seguridad.',
  },
  'RS-011': {
    NAME: 'Interceptación de tráfico de API sin cifrar',
    DESCRIPTION: 'Un atacante intercepta tráfico de API sin cifrar en líneas de comunicación desprotegidas.',
  },
  'RS-012': {
    NAME: 'Escucha de comunicaciones sin cifrar',
    DESCRIPTION: 'Se interceptan comunicaciones sin cifrar, incluidas credenciales transmitidas en texto claro.',
  },
  'RS-013': {
    NAME: 'Exfiltración de documentos sensibles del almacenamiento cloud',
    DESCRIPTION:
      'Se exfiltran documentos sensibles del almacenamiento cloud. No existe una política de clasificación de datos y los archivos sensibles no están protegidos ni etiquetados.',
  },
  'RS-014': {
    NAME: 'Robo de credenciales de la consola cloud sin MFA',
    DESCRIPTION:
      'Se roban las credenciales de la consola cloud por falta de MFA. El atacante obtiene acceso de administrador completo al entorno cloud.',
  },
  'RS-015': {
    NAME: 'Copia de seguridad expuesta con datos personales de clientes',
    DESCRIPTION:
      'Una copia de seguridad de la base de datos de producción con datos personales de clientes queda expuesta por permisos mal configurados en el almacenamiento cloud.',
  },
  'RS-016': {
    NAME: 'Ataque de inyección contra un endpoint de API',
    DESCRIPTION:
      'Se explota un endpoint de API sin validación de entradas mediante ataques de inyección. Las pruebas insuficientes y la falta de análisis de IaC no detectan el fallo.',
  },
  'RS-017': {
    NAME: 'Compromiso del pipeline de CI/CD por secretos en el código',
    DESCRIPTION:
      'El pipeline de CI/CD se ve comprometido por secretos incrustados en el código fuente. Se inyecta código malicioso en las compilaciones de producción.',
  },
  'RS-018': {
    NAME: 'Explotación del navegador en el equipo de un empleado remoto',
    DESCRIPTION:
      'Un empleado remoto visita un sitio web comprometido que explota una vulnerabilidad del navegador. Una protección de endpoints débil y la falta de formación de acogida en seguridad dejan el riesgo sin gestionar.',
  },
  'RS-019': {
    NAME: 'Ataque man-in-the-middle en las comunicaciones de API',
    DESCRIPTION:
      'Un atacante realiza un ataque man-in-the-middle en las comunicaciones de API y reutiliza tokens robados por una autenticación débil y la falta de MFA.',
  },
  'RS-020': {
    NAME: 'Tratamiento de datos personales sin EIPD',
    DESCRIPTION:
      'Se tratan datos personales para una nueva funcionalidad sin realizar una evaluación de impacto (EIPD).',
  },
  'RS-021': {
    NAME: 'Base de datos de producción expuesta por un grupo de seguridad mal configurado',
    DESCRIPTION:
      'Un grupo de seguridad cloud mal configurado expone una base de datos de producción a internet. Ninguna herramienta CSPM lo detecta.',
  },
  'RS-022': {
    NAME: 'Vulnerabilidad explotada en software no aprobado',
    DESCRIPTION:
      'Se adoptan librerías de código abierto no aprobadas y SaaS sin licencia sin evaluar al proveedor. Una de ellas contiene una vulnerabilidad que se explota.',
  },
  'RS-023': {
    NAME: 'Corrupción de la base de datos de producción con copias sin probar',
    DESCRIPTION:
      'Un despliegue defectuoso corrompe la base de datos cloud principal. Las copias de seguridad no están probadas, los registros cloud son insuficientes y la corrupción se propaga antes de detectarse.',
  },
  'RS-024': {
    NAME: 'Cesión de datos personales sin base legal',
    DESCRIPTION:
      'Se ceden datos personales de clientes a un tercero sin base legal ni acuerdos de encargo del tratamiento.',
  },
  'RS-025': {
    NAME: 'Propagación de malware desde software no verificado',
    DESCRIPTION:
      'Un malware infecta un dispositivo corporativo a través de software no verificado. Ni un proceso de gestión de vulnerabilidades ni la protección de endpoints impiden que se propague al almacenamiento cloud.',
  },
  'RS-026': {
    NAME: 'Borrado o cambio de permisos accidental en la consola cloud',
    DESCRIPTION:
      'Un error grave en la consola cloud borra por accidente un recurso de producción o altera permisos IAM. Ninguna salvaguarda CSPM impide acciones peligrosas.',
  },
  'RS-027': {
    NAME: 'Abuso interno de roles IAM con permisos excesivos',
    DESCRIPTION:
      'Un empleado con roles IAM demasiado permisivos accede a bases de datos de clientes más allá de su función. No existe un proceso periódico de revisión de accesos ni de recertificación de roles.',
  },
  'RS-028': {
    NAME: 'Falsificación de tokens IAM u OAuth',
    DESCRIPTION: 'Un atacante falsifica tokens IAM u OAuth aprovechando una autenticación débil y la falta de MFA.',
  },
  'RS-029': {
    NAME: 'Cambio de configuración sin trazabilidad',
    DESCRIPTION:
      'No se puede atribuir un cambio de configuración que provocó un incidente en producción. Faltan registros cloud y la configuración de la pista de auditoría es insuficiente.',
  },
  'RS-030': {
    NAME: 'Operaciones degradadas por conocimiento de seguridad concentrado',
    DESCRIPTION:
      'La falta de un rol de seguridad dedicado, una mala transferencia de conocimiento y la concentración de la experiencia degradan las operaciones.',
  },
  'RS-031': {
    NAME: 'Programa de seguridad sin presupuesto suficiente',
    DESCRIPTION:
      'La inversión en seguridad pierde prioridad por un presupuesto limitado. No existe el rol de CISO y no se realizan evaluaciones de riesgos.',
  },
  'RS-032': {
    NAME: 'Cese repentino de un proveedor cloud o SaaS clave',
    DESCRIPTION:
      'Un proveedor cloud o SaaS clave cesa su actividad de forma repentina. No existe evaluación del proveedor ni plan de contingencia ante su caída.',
  },
  'RS-033': {
    NAME: 'Auditoría de cumplimiento del RGPD no superada',
    DESCRIPTION:
      'La organización no supera una auditoría de cumplimiento del RGPD/LOPDGDD. No hay DPD designado, no se hacen auditorías periódicas y el registro de actividades de tratamiento está incompleto.',
  },
  'RS-034': {
    NAME: 'Incendio en la sala de servidores o en la zona del rack de telecomunicaciones',
    DESCRIPTION:
      'Se declara un incendio en la zona del rack de telecomunicaciones o la sala de servidores. La protección física es insuficiente y no hay un plan de continuidad ante la pérdida de activos físicos.',
  },
  'RS-035': {
    NAME: 'Daños por agua en la zona del rack de telecomunicaciones',
    DESCRIPTION:
      'Una tubería rota o una fuga de agua daña la zona del rack de telecomunicaciones. La protección insuficiente y un plan de continuidad desactualizado impiden una recuperación rápida.',
  },
  'RS-036': {
    NAME: 'Robo de portátiles o dispositivos',
    DESCRIPTION: 'Se roban portátiles o dispositivos por controles de acceso físico inadecuados.',
  },
  'RS-037': {
    NAME: 'Acceso no autorizado a la sala de servidores',
    DESCRIPTION:
      'Una persona no autorizada accede a la sala de servidores o a la zona del rack. Los controles físicos inadecuados y el personal externo sin supervisión permiten la manipulación de dispositivos.',
  },
  'RS-038': {
    NAME: 'Toma de control de cuentas de administrador',
    DESCRIPTION:
      'La falta de MFA, las contraseñas de administrador compartidas y la ausencia de alertas de accesos anómalos permiten tomar el control total de las cuentas de administrador.',
  },
  'RS-039': {
    NAME: 'Bucket de almacenamiento cloud accesible públicamente',
    DESCRIPTION:
      'Un bucket de almacenamiento cloud queda accesible públicamente. Ninguna herramienta CSPM detecta la exposición y los escáneres automáticos descubren e indexan datos de clientes en pocas horas.',
  },
  'RS-040': {
    NAME: 'Vulnerabilidad crítica conocida en una imagen de contenedor en producción',
    DESCRIPTION:
      'Una imagen de contenedor en producción contiene una vulnerabilidad crítica conocida. No existe un proceso formal de gestión de vulnerabilidades para clasificarla y corregirla.',
  },
  'RS-041': {
    NAME: 'Herramienta o paquete de CI/CD de terceros comprometido',
    DESCRIPTION:
      'Una herramienta o paquete de CI/CD de terceros comprometido inyecta código malicioso. Los contratos débiles con proveedores, la falta de evaluación de proveedores y la adopción sin control lo permiten.',
  },
  'RS-042': {
    NAME: 'Descarga de datos de clientes por una autenticación de API rota',
    DESCRIPTION:
      'Se explota un endpoint de API inseguro con la autenticación rota para enumerar y descargar registros de clientes.',
  },
  'RS-043': {
    NAME: 'Acceso a datos entre clientes en un producto multi-tenant',
    DESCRIPTION:
      'Un fallo en un producto SaaS multi-tenant permite acceder a datos de otros clientes por la falta de segmentación de VPC y una arquitectura insegura.',
  },
  'RS-044': {
    NAME: 'Inyección de código a través de una función serverless',
    DESCRIPTION:
      'Se inyecta código malicioso a través de la fuente de eventos de una función serverless que no valida las entradas.',
  },
  'RS-045': {
    NAME: 'Puerta trasera inyectada a través de un pipeline de CI/CD comprometido',
    DESCRIPTION:
      'El pipeline de CI/CD se ve comprometido por una dependencia vulnerable o credenciales de desarrollador robadas. Los secretos incrustados en el código y un control de cambios débil permiten inyectar una puerta trasera.',
  },
  'RS-046': {
    NAME: 'Uso de herramientas SaaS no aprobadas por parte de los empleados',
    DESCRIPTION:
      'Los empleados adoptan herramientas SaaS no aprobadas sin supervisión de IT. Ningún proceso de acogida comunica las herramientas aprobadas ni las políticas de uso aceptable.',
  },
  'RS-047': {
    NAME: 'Proliferación de configuraciones erróneas sin gobierno cloud',
    DESCRIPTION:
      'Sin CSPM, sin control de cambios y sin evaluación de riesgos, las configuraciones erróneas se multiplican.',
  },
  'RS-048': {
    NAME: 'Incidente sin resolver por falta de personal de respaldo',
    DESCRIPTION:
      'No hay personal de respaldo, credenciales documentadas ni transferencia de conocimiento. Un incidente en producción queda sin resolver.',
  },
  'RS-049': {
    NAME: 'Robo de sesiones en redes Wi-Fi públicas',
    DESCRIPTION:
      'Un empleado remoto usa una red Wi-Fi pública sin VPN. Una protección de endpoints débil permite capturar cookies de sesión y tokens que dan acceso a los servicios cloud.',
  },
  'RS-050': {
    NAME: 'Antiguo empleado que conserva sus accesos',
    DESCRIPTION:
      'Un empleado que deja la empresa conserva el acceso a servicios cloud y repositorios por la falta de un proceso formal de salida.',
  },
  'RS-052': {
    NAME: 'Tratamiento de datos personales a gran escala sin DPD',
    DESCRIPTION:
      'La organización trata datos personales de la UE a gran escala sin designar un DPD, mantener el registro de actividades de tratamiento ni realizar auditorías.',
  },
  'RS-053': {
    NAME: 'Notificación tardía de una brecha a la AEPD',
    DESCRIPTION:
      'Tras una brecha de datos, la organización no la notifica a la AEPD en 72 horas. No existe un procedimiento de notificación de brechas ni una monitorización adecuada.',
  },
  'RS-054': {
    NAME: 'Transferencias internacionales de datos sin garantías',
    DESCRIPTION:
      'Se transfieren datos de clientes fuera del EEE sin cláusulas contractuales tipo ni otras garantías. No hay acuerdos de encargo con los subencargados y las cláusulas contractuales son insuficientes.',
  },
  'RS-057': {
    NAME: 'Cookies de seguimiento sin consentimiento',
    DESCRIPTION:
      'Se usan cookies de seguimiento y analítica sin una gestión adecuada del consentimiento según la LSSI-CE. No hay un banner de cookies conforme.',
  },
  'RS-058': {
    NAME: 'Respuesta improvisada a un incidente de seguridad',
    DESCRIPTION:
      'Se produce un incidente de seguridad y la organización no tiene un proceso formal de gestión de incidentes. La detección, la contención y la comunicación se improvisan y se retrasan.',
  },
  'RS-059': {
    NAME: 'Exposición accidental de datos por nuevos empleados',
    DESCRIPTION:
      'Los nuevos empleados reciben acceso a sistemas de producción sin una acogida formal en seguridad. Los permisos mal configurados y la poca concienciación provocan una exposición accidental de datos.',
  },
  'RS-062': {
    NAME: 'Pico de tráfico que desborda la infraestructura cloud',
    DESCRIPTION:
      'Un pico de tráfico inesperado desborda la infraestructura cloud. El autoescalado está mal configurado y no se ha hecho planificación de capacidad ni pruebas de carga.',
  },
  'RS-063': {
    NAME: 'Claves de API y secretos en los repositorios de código',
    DESCRIPTION:
      'Hay claves de API y secretos incrustados en los repositorios de código. Un atacante o un antiguo empleado los descubre y obtiene acceso no autorizado.',
  },
  'RS-064': {
    NAME: 'Portátil perdido o robado sin cifrado ni borrado remoto',
    DESCRIPTION:
      'Se pierde o se roba el portátil de un empleado durante un viaje. Sin MDM, borrado remoto ni cifrado de disco completo, los datos sensibles de la empresa y de los clientes quedan expuestos y no se puede revocar el acceso a distancia.',
  },
  'RS-065': {
    NAME: 'Fallo de hardware crítico por antigüedad o desgaste',
    DESCRIPTION:
      'Un portátil crítico, un NAS o dispositivo de copias o un servidor local falla de forma inesperada por antigüedad o desgaste. Las copias de seguridad locales quedan temporalmente inaccesibles.',
  },
  'RS-066': {
    NAME: 'Dispositivo USB malicioso o keylogger de hardware',
    DESCRIPTION:
      'Durante una visita sin supervisión se conecta un dispositivo USB malicioso o un keylogger de hardware a un equipo de trabajo, que captura credenciales sin ser detectado por la falta de controles de endpoints y puertos USB.',
  },
  'RS-067': {
    NAME: 'Inyección de prompts en una funcionalidad basada en LLM',
    DESCRIPTION:
      'Un atacante inyecta instrucciones maliciosas a través de la entrada del usuario (inyección de prompts) en una funcionalidad de producción basada en LLM, o manipula un modelo fundacional de terceros para que filtre prompts de sistema o eluda sus salvaguardas, por una validación de entradas insuficiente y la falta de pruebas adversarias antes del despliegue.',
  },
  'RS-068': {
    NAME: 'Resultados sesgados o alucinados de un modelo de IA propio',
    DESCRIPTION:
      'Un modelo de IA propio entrenado con datos mal gobernados o poco representativos produce resultados sesgados o alucinados en producción. El problema pasa desapercibido por la falta de monitorización continua del modelo y de detección de deriva, lo que lleva a decisiones de negocio incorrectas o a daños a clientes.',
  },
} satisfies Record<IRiskCatalogueScenarioCode, { NAME: string; DESCRIPTION: string }>

export const RISK_CATALOGUE = {
  NEW_RISK_OPTIONS: 'Más formas de crear un riesgo',
  FROM_CATALOGUE: 'Desde el catálogo',
  BLANK_RISK: 'En blanco',
  TITLE: 'Catálogo de Riesgos',
  DESCRIPTION: 'Añade escenarios ISO 27005 como riesgos, con amenazas y vulnerabilidades ya rellenadas.',
  SEARCH: 'Buscar escenario, amenaza o vulnerabilidad',
  ALL_CATEGORIES: 'Todas las categorías',
  COLUMNS: {
    CATEGORY: 'Categoría de activo',
    ID: 'ID',
    SCENARIO: 'Escenario',
    THREAT: 'Amenaza',
    VULNERABILITIES: 'Vulnerabilidades',
    IMPACT: 'Impacto',
  },
  NO_RESULTS: 'No se han encontrado escenarios',
  NONE_SELECTED: 'Ningún escenario seleccionado',
  SELECTED_COUNT: (count: number) => `${count} ${count === 1 ? 'escenario seleccionado' : 'escenarios seleccionados'}`,
  CANCEL: 'Cancelar',
  ADD: (count: number) => (count > 1 ? `Añadir ${count} riesgos` : 'Añadir riesgo'),
  ADDED: (count: number) => `${count} ${count === 1 ? 'riesgo añadido' : 'riesgos añadidos'}`,
}
